import cx from 'classnames';
import { OverlayScrollbarsComponent } from 'overlayscrollbars-react';
// eslint-disable-next-line import/no-extraneous-dependencies
import { Resizable } from 're-resizable';
import React from 'react';
import styles from '../layout.module.scss';
const SIDE_PANEL_EXPANDED_MIN_WIDTH_PX = 180;
const SIDE_PANEL_COLLAPSED_WIDTH_PX = 0;
const SIDE_PANEL_EXPANDED_MAX_WIDTH_PX = 500;
export const LeftSideBar = ({ children, isLeftPanelExpanded, isLeftPanelFloating, leftPanelMinWidth = SIDE_PANEL_EXPANDED_MIN_WIDTH_PX, leftPanelMaxWidth = SIDE_PANEL_EXPANDED_MAX_WIDTH_PX, isLeftPanelResizable = false, className, }) => {
    const leftPanelFloatingMinWidth = SIDE_PANEL_COLLAPSED_WIDTH_PX;
    const leftPanelFloatingMaxWidth = SIDE_PANEL_COLLAPSED_WIDTH_PX;
    return (React.createElement(Resizable, { as: "section", className: cx(styles.sidePanel, styles.leftPanel, {
            [styles.floating]: isLeftPanelFloating,
            [styles.expanded]: isLeftPanelExpanded,
        }, className), minWidth: isLeftPanelExpanded
            ? leftPanelMinWidth
            : leftPanelFloatingMinWidth, maxWidth: isLeftPanelExpanded
            ? leftPanelMaxWidth
            : leftPanelFloatingMaxWidth, defaultSize: { width: '260px', height: 'auto' }, enable: {
            top: false,
            right: isLeftPanelExpanded && isLeftPanelResizable,
            bottom: false,
            left: false,
            topRight: false,
            bottomRight: false,
            bottomLeft: false,
            topLeft: false,
        }, handleComponent: {
            right: React.createElement("div", null),
        }, handleClasses: {
            right: styles.resizeHandle,
        } },
        React.createElement(OverlayScrollbarsComponent, { options: {
                // Grow-only auto-sizing caches a stale max-height when nav
                // content collapses, breaking scroll.
                sizeAutoCapable: false,
                scrollbars: { autoHide: 'move' },
            }, className: styles.sidebarOverlayScroll },
            React.createElement("div", { className: styles.innerContainer }, children))));
};
//# sourceMappingURL=left-sidebar.js.map